

































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import JwtStorageService from '../../../services/shared/auth/jwt-storage.service';
import pickcookComponentRouter from '@/router/modules/pickcook-component';
import AdminService from '../../../services/admin.service';
import { AdminDto } from '@/dto';
import { BaseUser } from '@/services/shared/auth';
import NavBarList from '../NavBar/NavBarList.layout.vue';
import NavBarAccount from '../NavBar/NavBarAccount.layout.vue';

@Component({
  name: 'PickcookLayout',
  components: {
    NavBarList,
    NavBarAccount,
  },
})
export default class PickcookLayout extends BaseComponent {
  private items = pickcookComponentRouter;
}
